import React, { Component } from 'react'
import Hero from "../Components/Hero"
import Intro from  "../Components/Intro"
import Footer from "../Components/Footer"
import Cred from '../Components/Cred'

function Gallery() {
    return (
        <div>
        <Cred />
        <Hero />
        <Intro />
        <Footer />
        </div>
    )
  }
  
  export default Gallery
